import { render, staticRenderFns } from "./ModalCloseButton.vue?vue&type=template&id=b3e9aaae&scoped=true&"
import script from "./ModalCloseButton.vue?vue&type=script&lang=js&"
export * from "./ModalCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./ModalCloseButton.vue?vue&type=style&index=0&id=b3e9aaae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e9aaae",
  null
  
)

export default component.exports